; (function () {
    angular.module('EMR.Admin').service("AutoLogOutTrackingService", AutoLogOutTrackingService);
    AutoLogOutTrackingService.$inject = ['$http','GoogleCloudFunctionHandlerService'];

    function AutoLogOutTrackingService(http,GoogleCloudFunctionHandlerService) {

        function isAutoLogOutTrackingEnabledPractice() {
            return new Set([999, 441]).has(EMRPracticeModel.PracticeID);
        }

        this.sendAutoLogOutInfoToTechSupport = function (reason) {
            
            if(!isAutoLogOutTrackingEnabledPractice()) return;

            const subject = `Auto LogOut Information for ${EMRPracticeModel && EMRPracticeModel.LoggedUserName} `;

            const body = buildAutoLogOutMessageBody(reason);

            sendMailToTechSupport(subject, body);
        }

        function buildAutoLogOutMessageBody(reason) {

            var bodyHTML = `
                     <html><body>
                     <B>Practice Info       : </B><br />  <br />
                     <B>Practice Name     : </B> ${EMRPracticeModel.PracticeName} <br>
                     <B>Logged UserName   : </B> ${EMRPracticeModel.LoggedUserName}<br>
                     <B>Practice ID     : </B> ${EMRPracticeModel.PracticeID}<br>
                     <B>Date & Time       : </B> ${adminGetCurrentDateAndTime() || new Date()}<br>
                     <B>Logged Out Reason : </B> ${reason}<br>
                     `

            return window.btoa(decodeURIComponent(encodeURIComponent(bodyHTML)));

        }

        function sendMailToTechSupport(mailSubject, mailBody) {
            if (!mailSubject || !mailBody) return;
            let toMails = []
            // var primaryWCFURL = getPrimaryWCFURL();
            // if (!primaryWCFURL) return;
            // const url = `${primaryWCFURL}EHR_SendMailAPI/EHRMailController/SendAngularjsErrortoTechSupport`;
            const requestBody = {
                mailSubject,
                mailBody,
                toMails
            };

            //sendMail(url, requestBody);
              GoogleCloudFunctionHandlerService.post("EHR_SendAngularjsErrortoTechSupport_GCloudFunc", requestBody).then(function (response) {
                 if (isError(response)) {
                     return;
                 }
             });
        }

        function sendMail(url, requestData) {
            http.post(url, requestData);
        }

        function getPrimaryWCFURL() {
            if (!EMRCommonService) return;
            var primaryWCFURL = angular.copy(EMRCommonService);
            primaryWCFURL = primaryWCFURL.replace("https://", "");
            primaryWCFURL = primaryWCFURL.replace("http://", "");
            primaryWCFURL = primaryWCFURL.split("/");
            if (primaryWCFURL && primaryWCFURL.length > 0)
                return "https://" + primaryWCFURL[0] + "/";
            else return "";
        }
    }

})();
